import { Focused } from "react-credit-cards";

export default class Card {
    public tcNo: string = "";
    public cvc: string = "";
    public expiry: string = "";
    public focus: Focused;
    public name: string = "";
    public cardNo: string = "";
    public pan: string = "";
    public expiryMonth: string = "";
    public expiryYear: string = "";

    constructor() {
        this.tcNo = "";
        this.cvc = "";
        this.expiry = "";
        this.focus = "name";
        this.name = "";
        this.cardNo = "";
        this.pan = "";
        this.expiryMonth = "";
        this.expiryYear = "";
    }
}
